<template>
	<div class="card card-popup card-popup__explanation" :style="{ 'background-image': backgroundImage }">
		
		<div class="content-container">
			

			<div class="header__container header__container-explanation">
				<div class="header header-white" style="position: relative">
					{{roundData.questions.header}}
				</div>
				<div class="subHeader subHeader-white" style="position: relative">
					{{roundData.questions.subheader}}
				</div>
				<div class="text text-white" style="position: relative" v-html="fullHTML"></div>
			</div>

			<Lottie
					name="explenation-animation"
					loop="true"
					ratio="meet"
					:animationpath="baseUrl + roundData.questions.visual"
					style="margin:auto;
					position: relative"
					v-if="visualExists && visualIsJson"/>
					
			<div v-else-if="visualExists" class="visual centered">
				<img
						:src="baseUrl + roundData.questions.visual"
						class="visual"
				/>
			</div>


			


			<div @click="onClick" class="btn btn-progres btn-progres-utrecht-whiteLine">
				<span v-if="language == 'NL'">sluit</span>
				<span v-else-if="language == 'FR'">fermer</span>
				<span v-else>close</span>
			</div>

		</div>

	</div>
</template>

<script>

	import { url} from '../../const/base';

	import {mapGetters , mapActions} from 'vuex';
	import Lottie from '../Lottie.vue';

	export default {
		components:{
			Lottie,
		},



		props: [
			'onClick',
			'additionalHTML',
		],

		mounted(){
			
		},
		data(){
			return {
				baseUrl : url
			}
		},
		methods:{
			...mapActions([
				'setNextButtonAction',
				'showNextButton',
				'setRoundState',
				'setRoundExplained'
			]),
		},
		computed:{
			...mapGetters([
				'roundData',
				"stageData",
			]),

			fullHTML(){
				let html = this.roundData.questions.explanation;

				if(typeof this.additionalHTML !== 'undefined'){
					if(this.additionalHTML !== ''){
						html +=  '<div class="additional-html">';
						html +=  this.additionalHTML
						html +=  '</div>';
					}
				}

				return html;
			},

			visualExists(){
				return this.roundData != null && this.roundData.questions.visual != null;
			},

			visualIsJson(){
				if(this.roundData == null || this.roundData.questions.visual == null) return false;
				let fileExtension = this.roundData.questions.visual.substr(this.roundData.questions.visual.lastIndexOf('.') + 1);
				return fileExtension.toLowerCase() == 'json';
			},

			backgroundImage: function() {
		        return 'url('+ this.baseUrl + this.roundData.questions.explanation_background + ')';
		    },
		},

	}
</script>


// WEBPACK FOOTER //
// src/components/minigames/ExplanationPopup.vue